// extracted by mini-css-extract-plugin
export default {"wrap":"Links_wrap__PvIGS","links":"Links_links__Ehak9","link":"Links_link__j8Zhf","linksLarge":"Links_linksLarge__x5oRM","icon":"Links_icon__RWUHL"};